export enum PortalCitizenshipType {
  US_CITIZEN = 'US Citizen',
  PERMANENT_RESIDENT = 'Permanent Resident',
  NON_PERMANENT_RESIDENT = 'Non-permanent Resident',
  FOREIGN_NATIONAL = 'Foreign National'
}